import { useEffect, useState } from 'react';
import { fetchProducts } from '../api/productApi';
import { Product } from '../types/product'

export const useProducts = () => {
    const [products, setProducts] = useState<Product[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const getProducts = async () => {
            try {
                const result = await fetchProducts();
                setProducts(result);
            } catch (err) {
                setError('Не удалось загрузить продукты');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        getProducts();
    }, []);

    return { products, loading, error };
};
